import { Component, OnInit } from '@angular/core';
import { finalize, forkJoin } from 'rxjs';
import {
  B2cAnalyticsService, B2cAnalyticsSummary, B2cAnalyticsVisitor, B2cRegistration, B2cSearchQuery
} from './b2c-analytics.service';

@Component({
  selector: 'app-b2c-analytics',
  templateUrl: './b2c-analytics.component.html',
  styleUrls: ['./b2c-analytics.component.scss']
})
export class B2cAnalyticsComponent implements OnInit {
  summary: B2cAnalyticsSummary | null = null;
  visitors: B2cAnalyticsVisitor[] = [];
  registrations: B2cRegistration[] = [];
  searchQueries: B2cSearchQuery[] = [];
  selectedVisitor: any = null;
  loading = false;
  detailLoading = false;
  error = '';
  fromDate = this.dateInput(new Date());
  toDate = this.dateInput(new Date());
  registered = '';
  hasCart = '';
  search = '';
  location = '';
  event = '';
  searchResult = '';

  constructor(private analytics: B2cAnalyticsService) {}
  ngOnInit() { this.load(); }

  load() {
    this.loading = true;
    this.error = '';
    const { from, to } = this.range();
    forkJoin({
      summary: this.analytics.summary(from, to),
      visitors: this.analytics.visitors(from, to, {
        registered: this.registered, hasCart: this.hasCart, search: this.search.trim(),
        location: this.location.trim(), event: this.event
      }),
      registrations: this.analytics.registrations(from, to),
      searches: this.analytics.searches(from, to, { hasResults: this.searchResult })
    }).pipe(finalize(() => this.loading = false)).subscribe({
      next: (result) => {
        this.summary = result.summary;
        this.visitors = result.visitors.items;
        this.registrations = result.registrations.items;
        this.searchQueries = result.searches.items;
      },
      error: () => this.error = 'Не удалось загрузить B2C-аналитику.'
    });
  }
  openVisitor(visitor: B2cAnalyticsVisitor) {
    this.openVisitorById(visitor.id);
  }
  openVisitorById(id: number) {
    this.detailLoading = true;
    this.analytics.visitor(id).pipe(finalize(() => this.detailLoading = false)).subscribe({
      next: (detail) => this.selectedVisitor = detail,
      error: () => this.error = 'Не удалось открыть историю посетителя.'
    });
  }
  closeVisitor() { this.selectedVisitor = null; }
  copiedVin = '';
  copyVin(vin: string) {
    navigator.clipboard?.writeText(vin).then(() => {
      this.copiedVin = vin;
      setTimeout(() => this.copiedVin = '', 1500);
    });
  }
  duration(seconds: number) {
    const value = Number(seconds || 0);
    if (value < 60) return `${value} сек`;
    const minutes = Math.floor(value / 60);
    return minutes < 60 ? `${minutes} мин` : `${Math.floor(minutes / 60)} ч ${minutes % 60} мин`;
  }
  conversion(value: number) {
    const base = Number(this.summary?.visitors || 0);
    return base ? `${(Number(value || 0) * 100 / base).toFixed(1)}%` : '0%';
  }
  sourceLabel(source: string) {
    return ({
      google_ads: 'Google Ads',
      google_organic: 'Google органика',
      google_unattributed: 'Google (канал не определён)',
      direct: 'Прямые заходы',
      other_campaign: 'Другие кампании',
      referral: 'Переходы с сайтов'
    } as Record<string, string>)[source] || source;
  }
  private range() {
    const from = new Date(`${this.fromDate}T00:00:00`);
    const to = new Date(`${this.toDate}T00:00:00`);
    to.setDate(to.getDate() + 1);
    return { from: from.toISOString(), to: to.toISOString() };
  }
  private dateInput(date: Date) {
    const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return local.toISOString().slice(0, 10);
  }
}
